function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Videos",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Large",
  transform: "translate(-687.000000, -2766.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Footer",
  transform: "translate(0.000000, 2559.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Social-icons",
  transform: "translate(625.000000, 195.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "instagram",
  transform: "translate(50.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "instagram",
  transform: "translate(12.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.4645141,10.4812978 C14.4645141,12.6816703 12.6805933,14.4645141 10.4812978,14.4645141 L5.51906119,14.4645141 C3.31868872,14.4645141 1.53512689,12.6816703 1.53512689,10.4812978 L1.53512689,5.51906119 C1.53512689,3.31976575 3.31868872,1.5354859 5.51906119,1.5354859 L10.4812978,1.5354859 C12.6805933,1.5354859 14.4645141,3.31976575 14.4645141,5.51906119 L14.4645141,10.4812978 Z M11.0707923,0 L4.92992573,0 C2.20683465,0 0,2.20719366 0,4.93028474 L0,11.0707923 C0,13.7931653 2.20683465,16 4.92992573,16 L11.0707923,16 C13.7935244,16 16,13.7931653 16,11.0707923 L16,4.93028474 C16,2.20719366 13.7935244,0 11.0707923,0 L11.0707923,0 Z",
  id: "Fill-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.00034074,10.4059971 C6.67041486,10.4059971 5.59332141,9.32788142 5.59332141,7.99965926 C5.59332141,6.66973337 6.67041486,5.59298066 8.00034074,5.59298066 C9.32890365,5.59298066 10.4066786,6.66973337 10.4066786,7.99965926 C10.4066786,9.32788142 9.32890365,10.4059971 8.00034074,10.4059971 M8.00034074,4 C5.79061249,4 4,5.789931 4,7.99965926 C4,10.2080245 5.79061249,11.9996593 8.00034074,11.9996593 C10.2090468,11.9996593 12,10.2080245 12,7.99965926 C12,5.789931 10.2090468,4 8.00034074,4",
  id: "Fill-3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9998325,3 C11.4476462,3 11,3.44842599 11,4.0003349 C11,4.5525787 11.4476462,5 11.9998325,5 C12.5513486,5 13,4.5525787 13,4.0003349 C13,3.44842599 12.5513486,3 11.9998325,3",
  id: "Fill-1"
})))))));

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Social / Instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.d8e37866.svg";
export { ForwardRef as ReactComponent };